import { renderCountryName } from '../../util/names'

export default () => {
    return [
        {
            property: 'firstName',
            header: 'Firstname',
            columnName: 'partner_partner.firstName',
        },
        {
            property: 'lastName',
            header: 'Lastname',
            columnName: 'partner_partner.lastName',
        },
        {
            property: 'active',
            header: 'Active',
            columnName: 'partner_partner.active',
        },
        {
            property: 'store',
            header: 'Associated Clinic',
            columnName: 'partner_partner.store',
        },
        {
            property: 'countryCode',
            header: 'Country',
            renderer: (customer) => {
                return renderCountryName(customer.countryCode)
            },
            columnName: 'partner_partner.countryCode',
        },
        {
            property: 'isTreatingPhysician',
            header: 'Is TreatingPhysician',
            columnName: 'partner_partner.isTreatingPhysician',
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/partner/component/search/partner-column-list.js